import m from "mithril";
import CoordMobileLayout from "./Coord-mobile-layout.js";
import Pager from "./components/Pager.js";
import CoordDashboardMobile from "./Coord-dashboard-mobile.js";
import CoordCustomerPortfolioMobile from "./CoordCustomerPortfolioMobile.js";

const CoordHomeMobile = {
    activeIndex: 0,

    oninit() {
        this.updateActiveIndex();
    },

    onupdate() {
        this.updateActiveIndex();
    },

    updateActiveIndex() {
        const route = m.route.get();
        if (route.includes('/coord-customer-portfolio-mobile')) {
            this.activeIndex = 1;
        } else {
            this.activeIndex = 0;
        }
    },

    handlePageChange(index) {
        this.activeIndex = index;
        const target = index === 0 ? "/coord-dashboard-mobile" : "/coord-customer-portfolio-mobile";
        if (m.route.get() !== target) {
            m.route.set(target);
        }
    },

    view() {
        const isExperimentalRoute = m.route.get().includes('/coord-customer-portfolio-mobile');

        // Dynamic navigation state:
        // Index 0 -> "dashboard"
        // Index 1 -> "nasabah"
        const activeSection = this.activeIndex === 0 ? "dashboard" : "nasabah";
        const title = isExperimentalRoute
            ? "Portfolio Experimental"
            : (this.activeIndex === 0 ? "Beranda" : "Portfolio Anggota");

        return m(CoordMobileLayout, { 
            activeSection: activeSection,
            title: title,
            hideBottomNav: isExperimentalRoute
        }, [
            isExperimentalRoute ? m("div", { class: "px-4 pt-3 pb-2" }, [
                m("div", { class: "flex items-center justify-between rounded-xl border border-blue-100 bg-blue-50 px-3 py-2 text-xs text-blue-700 dark:border-blue-900 dark:bg-blue-950/40 dark:text-blue-300" }, [
                    m("span", { class: "font-medium" }, "Mode experimental aktif"),
                    m("button", {
                        class: "font-semibold underline underline-offset-2",
                        onclick: () => m.route.set('/coord-dashboard-mobile')
                    }, "Kembali ke Legacy Mode")
                ])
            ]) : null,
            m(Pager, {
                activeIndex: this.activeIndex,
                onPageChange: (idx) => this.handlePageChange(idx)
            }, [
                m(CoordDashboardMobile, { isEmbedded: true }),
                m(CoordCustomerPortfolioMobile, { isEmbedded: true })
            ])
        ]);
    }
};

export default CoordHomeMobile;
